export default __webpack_public_path__ + "images/cd4e9b7291d49c450a45b14f5e89d2a8-auto_small.webp";